import React from 'react';
import {
    Row,
    Col,
} from 'reactstrap';
import Header from '../component/layout/Header';

function WIP() {
    return (
        <div>
            <Header />

            <Row className='p-3'>
                <Col xs="12" className='text-center'>
                    <img className='img-fluid' alt="loading..." src={require('./../assets/img/wip.gif')} />
                   <h1>Work in Progress</h1> 
                </Col>
            </Row>
        </div>
    )
}

export default WIP;